// Test IDs for PRAMID portal
export const CUSTOMER = {
  nameInput: "customer-name-input",
  companyInput: "customer-company-input",
  phoneInput: "customer-phone-input",
  submitBtn: "customer-entry-submit-btn",
  adminLink: "customer-admin-link",
};

export const WORKSPACE = {
  textTab: "workspace-tab-text",
  excelTab: "workspace-tab-excel",
  textarea: "workspace-bulk-textarea",
  excelInput: "workspace-excel-input",
  excelUploadBtn: "workspace-excel-upload-btn",
  pdfTab: "workspace-tab-pdf",
  pdfInput: "workspace-pdf-input",
  pdfUploadBtn: "workspace-pdf-upload-btn",
  calculateBtn: "workspace-calculate-btn",
  resetBtn: "workspace-reset-btn",
  resultsTable: "workspace-results-table",
  totalsList: "workspace-totals-list",
  totalsCash: "workspace-totals-cash",
  totalsCard: "workspace-totals-card",
  exportPdfBtn: "workspace-export-pdf-btn",
  exportExcelBtn: "workspace-export-excel-btn",
  newQueryBtn: "workspace-new-query-btn",
  logoutBtn: "workspace-logout-btn",
};

export const ADMIN = {
  emailInput: "admin-email-input",
  passwordInput: "admin-password-input",
  loginBtn: "admin-login-btn",
  navBrands: "admin-nav-brands",
  navQuotes: "admin-nav-quotes",
  navProducts: "admin-nav-products",
  navCategories: "admin-nav-categories",
  logoutBtn: "admin-logout-btn",
  // Brands
  addBrandBtn: "admin-add-brand-btn",
  brandNameInput: "admin-brand-name-input",
  brandCashInput: "admin-brand-cash-input",
  brandCardInput: "admin-brand-card-input",
  brandSaveBtn: "admin-brand-save-btn",
  brandUploadBtn: "admin-brand-upload-btn",
  brandDeleteBtn: "admin-brand-delete-btn",
  // Mapping
  mapCodeSelect: "admin-map-code-select",
  mapNameSelect: "admin-map-name-select",
  mapPriceSelect: "admin-map-price-select",
  mapImportBtn: "admin-map-import-btn",
  // Categories
  addCategoryBtn: "admin-add-category-btn",
  categoryKeyInput: "admin-category-key-input",
  categoryLabelInput: "admin-category-label-input",
  categoryKeywordsInput: "admin-category-keywords-input",
  categorySaveBtn: "admin-category-save-btn",
};

export const MANUAL_MATCH = {
  openBtn: "manual-match-open-btn",
  searchInput: "manual-match-search-input",
  resultsList: "manual-match-results-list",
  confirmBtn: "manual-match-confirm-btn",
};
